import * as angular from 'angular';
import { mgoAngularWizard } from '../custom';
import { TradeUploadWizardContext } from 'app/trade-upload-wizard/trade-upload-wizard.component';

class UploadWizardActionComponentCtrl implements ng.IController {
    private wizardCtrl: mgoAngularWizard.Wizard<TradeUploadWizardContext>;

    constructor(private $location: ng.ILocationService) {}

    $onInit() {}

    public cancel(): void {
        this.$location.path('/uploads');
    }

    public submit(isValid): boolean {
        if (!isValid) {
            return false;
        }
        this.wizardCtrl.next();
        return true;
    }
}

angular.module('app').component('pkpTradeUploadWizardAction', {
    controller: UploadWizardActionComponentCtrl,
    template:
        require('app/trade-upload-wizard/trade-upload-wizard-action.component.html'),
    require: {
        wizardCtrl: '^^wizard'
    },
    bindings: {}
});
